import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 15px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      marginTop: 24
    }
  },
  stickyDiv: {
    margin: '-23px -96px -23px -96px',
    height: '100px',
    background: theme.palette.grey[800],
    position: 'sticky',
    top: 65,
    left: 130,
    marginBottom: 12,
    zIndex: 12,
    [theme.breakpoints.down('sm')]: {
      top: 55,
      padding: '0 8px',
      margin: '-23px -16px -23px -16px',
      height: '70px'
    }
  },
  noResultFound: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(5)
  },
  img: {
    width: '25%',
    [theme.breakpoints.down('sm')]: {
      width: '35%'
    }
  },
  noResults: {
    marginTop: 16,
    fontWeight: 500,
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: '0 16px',
    [theme.breakpoints.down('sm')]: { padding: 8 }
  },

  backButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',

    marginBottom: 8
  },
  backBtn: { alignItems: 'center' },
  primaryTitle: {
    margin: '16px 0px',
    color: theme.palette.text.primary,
    fontSize: 20,
    [theme.breakpoints.down('sm')]: { fontSize: 16 }
  },

  availableRoomContainer: {
    display: 'grid',
    gridTemplateColumns: '2.9fr 1fr',
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' },
    gap: 32,
    position: 'relative'
  },
  roomTypesContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 2.5,
    marginRight: 8
  },
  filtersContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    top: 16,
    height: 'fit-content'
  },
  filterText: { fontWeight: 600, color: theme.palette.grey[800] },

  btnContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '14px',
    marginBottom: '14px',
    background: 'white',
    height: 100,
    zIndex: 1000,
    position: 'sticky',
    bottom: 0
  },
  bookingButton: {
    [theme.breakpoints.down('sm')]: {
      width: '45%'
    },
    width: '20%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  btnContinue: { width: '100%' },
  continueText: {
    color: theme.palette.primary.contrastText,
    fontSize: 16,
    fontWeight: 500
  },

  facilitiy: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
}))
export default useStyles
